<div class="aet-shell">

  <!-- scanlines -->
  <div class="aet-scanlines"></div>

  <!-- ══ HEADER ══ -->
  <span mat-dialog-title class="aet-title-anchor"></span>
  <div class="aet-header">
    <div class="aet-header__stripe"></div>
    <div class="aet-header__hero">
      <div class="aet-header__hero-ring">
        <mat-icon>{{ team.id ? 'edit' : 'shield' }}</mat-icon>
      </div>
      <div class="aet-header__hero-pulse"></div>
    </div>
    <div class="aet-header__text">
      <span class="aet-header__eyebrow">
        <span class="aet-header__eyebrow-dot"></span>
        ADMIN CONSOLE · {{ team.id ? 'EDIT' : 'NEW' }} SQUAD
      </span>
      <span class="aet-header__title">
        {{ 'ADMIN_ADD_TEAM_DIALOG.' + (team.id ? 'UPDATE_TITLE' : 'CREATE_TITLE') | translate }}
      </span>
      <span class="aet-header__sub">
        {{ 'ADMIN_ADD_TEAM_DIALOG.DESCRIPTION' | translate }}
      </span>
    </div>
    <button class="aet-close-btn" mat-dialog-close type="button" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- ══ BODY ══ -->
  <div mat-dialog-content class="aet-body">
    <form class="aet-form" #dialogForm="ngForm">
      <div class="container-fluid px-0">
        <div class="row g-3">

          <!-- Squad icon — centred, full row -->
          <div class="col-12 d-flex flex-column align-items-center">
            <span class="aet-section-label">
              <mat-icon>image</mat-icon>SQUAD ICON
            </span>
            <div class="aet-icon-picker">
              <app-image-picker
                keyPrefix="team"
                [image]="team.icon"
                (onImageSelect)="onTeamIconSelect($event)"
              ></app-image-picker>
            </div>
            <span class="aet-icon-hint" *ngIf="!team.icon">Click to upload squad icon</span>
          </div>

          <!-- Name + Description side by side on sm+ -->
          <div class="col-12 col-sm-6">
            <div class="aet-field-group">
              <label class="aet-label">
                <mat-icon>drive_file_rename_outline</mat-icon>
                {{ 'ADMIN_ADD_TEAM_DIALOG.NAME_INPUT.PLACEHOLDER' | translate }}
              </label>
              <mat-form-field appearance="outline" class="aet-field">
                <input matInput cdkFocusInitial type="text"
                       [(ngModel)]="team.name" name="team-name"
                       maxlength="20" required />
                <button mat-icon-button matSuffix *ngIf="team.name"
                        [attr.aria-label]="'BUTTON.CLEAR' | translate"
                        (click)="team.name = ''">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-hint>{{ 'ADMIN_ADD_TEAM_DIALOG.NAME_INPUT.HINT' | translate }}</mat-hint>
                <mat-error>{{ 'ADMIN_ADD_TEAM_DIALOG.NAME_INPUT.ERROR' | translate }}</mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="col-12 col-sm-6">
            <div class="aet-field-group">
              <label class="aet-label">
                <mat-icon>notes</mat-icon>
                {{ 'ADMIN_ADD_TEAM_DIALOG.DESCRIPTION_INPUT.PLACEHOLDER' | translate }}
              </label>
              <mat-form-field appearance="outline" class="aet-field">
                <input matInput type="text"
                       [(ngModel)]="team.description" name="team-description"
                       maxlength="100" required />
                <button mat-icon-button matSuffix *ngIf="team.description"
                        [attr.aria-label]="'BUTTON.CLEAR' | translate"
                        (click)="team.description = ''">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-hint>{{ 'ADMIN_ADD_TEAM_DIALOG.DESCRIPTION_INPUT.HINT' | translate }}</mat-hint>
                <mat-error>{{ 'ADMIN_ADD_TEAM_DIALOG.DESCRIPTION_INPUT.ERROR' | translate }}</mat-error>
              </mat-form-field>
            </div>
          </div>

          <!-- Team lead -->
          <div class="col-12">
            <div class="aet-section">
              <div class="aet-section__header">
                <mat-icon>star</mat-icon>
                <span>SQUAD LEAD</span>
                <div class="aet-section__line"></div>
              </div>
              <div class="aet-section__body">
                <app-agent-input-autocomplete
                  (selectionChange)="teamLeadCtrl.setValue($event)"
                  (agentsLoad)="isUsersLoading = false"
                  [roles]="roles"
                  [excludeMe]="false"
                  [initialAgentId]="data?.teamLeadId"
                  [placeholder]="'ADMIN_ADD_TEAM_DIALOG.TEAM_LEAD_SELECT.PLACEHOLDER' | translate"
                  [placeholderLabel]="'ADMIN_ADD_TEAM_DIALOG.TEAM_LEAD_SELECT.INPUT_PLACEHOLDER' | translate"
                  [hint]="'ADMIN_ADD_TEAM_DIALOG.TEAM_LEAD_SELECT.HINT' | translate"
                  [errorLabel]="'ADMIN_ADD_TEAM_DIALOG.TEAM_LEAD_SELECT.ERROR' | translate"
                ></app-agent-input-autocomplete>
              </div>
            </div>
          </div>

          <!-- Members -->
          <div class="col-12">
            <div class="aet-section">
              <div class="aet-section__header">
                <mat-icon>group</mat-icon>
                <span>SQUAD MEMBERS</span>
                <div class="aet-section__line"></div>
                <span class="aet-member-count">{{ members.length }}</span>
              </div>
              <div class="aet-section__body">
                <team-members-list
                  [members]="members"
                  (onAddMember)="addMember($event)"
                  (onRemoveMember)="removeMember($event)"
                ></team-members-list>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- loading bar -->
      <mat-progress-bar class="aet-progress" *ngIf="isUsersLoading" mode="indeterminate"></mat-progress-bar>

      <!-- error -->
      <div class="aet-error-banner" *ngIf="errorMessage">
        <mat-icon>warning_amber</mat-icon>
        <span>{{ errorMessage }}</span>
      </div>

    </form>
  </div>

  <!-- ══ FOOTER ══ -->
  <div mat-dialog-actions class="aet-footer">
    <div class="aet-footer__dots">
      <span class="aet-dot" [class.aet-dot--filled]="team.icon"></span>
      <span class="aet-dot" [class.aet-dot--filled]="team.name"></span>
      <span class="aet-dot" [class.aet-dot--filled]="team.description"></span>
      <span class="aet-dot" [class.aet-dot--filled]="teamLeadCtrl.value"></span>
    </div>
    <div class="aet-footer__actions">
      <button class="aet-btn aet-btn--cancel" mat-dialog-close type="button">
        <mat-icon>chevron_left</mat-icon>
        <span>{{ 'BUTTON.CANCEL' | translate }}</span>
      </button>
      <button class="aet-btn aet-btn--save" type="button"
              (click)="submit()"
              [disabled]="dialogForm.invalid || !team.icon || teamLeadCtrl.invalid || isUsersLoading">
        <mat-icon>{{ team.id ? 'save' : 'add' }}</mat-icon>
        <span>{{ 'ADMIN_ADD_TEAM_DIALOG.' + (team.id ? 'UPDATE_TEAM_BUTTON_TEXT' : 'CREATE_TEAM_BUTTON_TEXT') | translate }}</span>
      </button>
    </div>
  </div>

</div>
